import { Injectable } from '@angular/core';

import { createAction, props, Store } from '@ngrx/store';

import { IItemLocalization, ILanguage } from '../../api/grpc';
import { IAppState } from '../states/app.state';

export const SET_LANG = createAction('[language] Set language', props<{ language?: string }>());

export const GET_LANG_COMMAND = createAction('[language] Get language command');
export const GET_LANG_SUCCESS = createAction(
  '[language] Get language success',
  props<{ languages: Array<ILanguage> }>(),
);

export const GET_LACALIZATION_COMMAND = createAction('[language] Get localization command');
export const GET_LACALIZATION_SUCCESS = createAction(
  '[language] Get localization success',
  props<{ items: Array<IItemLocalization> }>(),
);

export const TOGGLE_DEV_MODE = createAction('[language] Toggle dev mode');

@Injectable({
  providedIn: 'root',
})
export class LanguageActionsService {
  constructor(private _store$: Store<IAppState>) {}

  setLang(language?: string) {
    this._store$.dispatch(SET_LANG({ language }));
  }
}
